import React from "react";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import Text from "@src/sharedComponents/Typography/Text";

import sharedStyles from "./shared.module.css";
import styles from "./TransitionLinksCard.module.css";

export interface LinkItem {
  title: string;
  subtitle?: string;
  url: string;
}

interface TransitionLinksCardProps {
  links: LinkItem[];
}

const TransitionLinksCard: React.FC<TransitionLinksCardProps> = ({ links }) => {
  if (links.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      {links.map((link, index) => (
        <div key={link.url}>
          <div className={styles.linkSection}>
            <div className={styles.leftContent}>
              <Text variant="title3" color="text">
                {link.title}
              </Text>
              {link.subtitle && (
                <Text variant="body" color="textSubtle">
                  {link.subtitle}
                </Text>
              )}
            </div>
            <a
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={sharedStyles.openLink}
            >
              <Text variant="body" color="text">
                Open
              </Text>
              <OpenInNewIcon className={styles.icon} />
            </a>
          </div>
          {index < links.length - 1 && <div className={styles.divider} />}
        </div>
      ))}
    </div>
  );
};

export default TransitionLinksCard;
